import { useTranslation } from 'react-i18next';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@repo/ui/components/ui/sheet';
import { Spinner } from '@repo/ui/components/molecules/spinner';
import { useNavigate } from '@tanstack/react-router';

interface SheetViewLoaderProps {
  returnUrl: string;
}

/**
 * Pannello d'attesa delle rotte che aprono una SheetView (`pendingComponent`).
 * Anche mentre carica il pannello è un dialogo: ha un titolo, visivamente
 * nascosto, altrimenti Radix lo segnala e il lettore di schermo non dice
 * cosa si è aperto.
 */
export function SheetViewLoader({ returnUrl }: SheetViewLoaderProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Sheet
      open={true}
      onOpenChange={() => navigate({ to: returnUrl, search: (old) => old })}
    >
      <SheetContent
        className="w-full sm:max-w-3xl flex flex-col items-center justify-center"
        disableCloseAnimation
        aria-describedby={undefined}
      >
        <SheetHeader className="sr-only">
          <SheetTitle>{t('commons.loading')}</SheetTitle>
        </SheetHeader>
        <Spinner />
      </SheetContent>
    </Sheet>
  );
}
